import { Check } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/AuthContext";
import { BACKGROUNDS, bgSrc } from "@/lib/backgrounds";

export const BackgroundPicker = () => {
  const { user, setBackground } = useAuth();
  const current = user?.background || "none";
  const pick = (id) => setBackground(id).catch(() => toast.error("Couldn't save background"));
  return (
    <div className="bg-bt-surface border border-bt-border-subtle p-6 mt-6" data-testid="background-picker">
      <h2 className="text-xs font-mono uppercase tracking-[0.2em] text-bt-text-secondary mb-1">Background</h2>
      <p className="text-xs text-bt-text-tertiary mb-4">
        Shown behind the app and on the sign-in page. It stays on the sign-in page on this device when "Remember my email" is ticked.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {BACKGROUNDS.map(b => {
          const thumb = bgSrc(b.id, true);
          const active = current === b.id;
          return (
            <button
              key={b.id}
              onClick={() => pick(b.id)}
              className={`group text-left border transition-colors ${active ? "border-bt-gold" : "border-bt-border-subtle hover:border-bt-border-focus"}`}
              data-testid={`bg-option-${b.id}`}
            >
              <span className="relative block aspect-[3/2] overflow-hidden bg-bt-surface-2">
                {thumb
                  ? <img src={thumb} alt={b.label} loading="lazy" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                  : <span className="absolute inset-0 flex items-center justify-center font-mono text-[10px] text-bt-text-tertiary">No image</span>}
                {active && (
                  <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-bt-gold flex items-center justify-center">
                    <Check className="w-3 h-3 text-bt-bg" strokeWidth={3} />
                  </span>
                )}
              </span>
              <span className={`block px-2 py-1.5 font-body text-[11px] ${active ? "text-bt-gold" : "text-bt-text-secondary"}`}>{b.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
